
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4 8a3 3 0 016 0v8a3 3 0 11-6 0V8zm3-1a1 1 0 00-1 1v8a1 1 0 102 0V8a1 1 0 00-1-1zM14 8a3 3 0 116 0v8a3 3 0 11-6 0V8zm3-1a1 1 0 00-1 1v8a1 1 0 102 0V8a1 1 0 00-1-1z"}})])
          )
        }
      }
    